import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  OTHER_ITEMS,
  SIDEBAR_MAIN_ITEMS,
} from 'app/helpers/constants/sideBarItems';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import {
  NonFeatureMenuItems,
  TenantFeatures,
} from 'app/state/feature.repository';

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  currentRoute = '';
  tenantFeatures = TenantFeatures;
  nonFeatureMenuItems = NonFeatureMenuItems;
  constructor(
    public generalDataRepo: GeneralDataRepository,
    public router: Router
  ) {
    this.router.events.subscribe((x) => {
      if (x instanceof NavigationEnd) {
        this.currentRoute = x.url;
      }
    });
  }
  navItems: any[] = [];

  ngOnInit() {
    this.generalDataRepo.allGeneralData$.subscribe((data) => {
      this.navItems = [];
      this.navItems.push(SIDEBAR_MAIN_ITEMS.homeMain);

      if (data.features.includes(TenantFeatures.Sprints)) {
        this.navItems.push(SIDEBAR_MAIN_ITEMS.colaborationsMain);
      }

      if (data.features.includes(TenantFeatures.ToolBox)) {
        this.navItems.push(SIDEBAR_MAIN_ITEMS.toolBoxMain);
      }

      if (data.features.includes(TenantFeatures.PersonalPlan)) {
        this.navItems.push(SIDEBAR_MAIN_ITEMS.personalplanMain);
      }

      this.navItems.push(SIDEBAR_MAIN_ITEMS.notificationsMain);

      this.navItems.push(OTHER_ITEMS.profile);
    });
  }

  checkUrl(url: string) {
    return (
      this.currentRoute.includes(url) ||
      (url === SIDEBAR_MAIN_ITEMS.homeMain.routerLink.toLowerCase() &&
        this.currentRoute === '/')
    );
  }
}
